import { sortForBack } from "../../utils/sortPagination";
import { ParamTopologiesPagination } from "./TreatmentSlice";

export const paginationForBack = (paramPagination: ParamTopologiesPagination) => {
     return {
        ...paramPagination,
        sort: sortForBack(paramPagination.sort),
        field: paramPagination.field ? paramPagination.field : "",
      };
}